import useMessageComposer from "./hooks/useMessageComposer";
import { P2 } from "../../components/Paragraph";
// import TextArea from "../forms/TextArea";
import Button from "../../components/Button";
import { useSelector } from "react-redux";
import {
  selectIsRightPanelOpen,
  selectIsRightPanelExpanded,
} from "../../app/rightPanelSlice";
import MathEditor from "./MathEditor";
import classNames from "classnames";
import styles from "./messageComposer.module.css";

const MessageComposer = ({ onSubmit, composerEnabled }) => {
  const composerAttribs = useMessageComposer({ onSubmit });
  const rightPanelOpen = useSelector(selectIsRightPanelOpen);
  const rightPanelExpanded = useSelector(selectIsRightPanelExpanded);

  return (
    <div className={styles.messageComposer}>
      <div
        className={classNames(styles.messageComposerContainerWithMargin, {
          [styles.rightPanelExpanded]: rightPanelOpen && rightPanelExpanded,
          [styles.rightPanelCollapsed]: rightPanelOpen && !rightPanelExpanded,
        })}
      >
        <div className={styles.messageComposerContainer}>
          <MathEditor {...composerAttribs} disabled={!composerEnabled} />
          <Button important>Send</Button>
          <P2 style={{ position: "absolute", bottom: "10px", left: "20px" }}>
            Use Alt+m (⌥+m) to enter math formula
          </P2>
        </div>
      </div>
    </div>
  );
};

export default MessageComposer;

/*
  <TextArea
    rows={"doubleFixed"}
    composer
    {...composerAttribs}
    disabled={!composerEnabled}
  />
*/
